<template>
  <div>
    <div class="home">
      <h2 class="title">
        {{ result.title }}
      </h2>
      <p v-html="result.content" />
      <img
        class="image"
        :src="result.images[0]"
      >
      <p>The following is a list of awards for {{ result.name }} Event:</p>
      <v2-table :data="result.result">
        <v2-table-column
          prop="rank"
          label="RANK"
          width="80"
        />
        <v2-table-column
          prop="name"
          label="NAME"
        />
        <v2-table-column
          prop="platform"
          label="PLATFORM"
        />
        <v2-table-column
          prop="prizes"
          label="PRIZES"
        />
      </v2-table>
    </div>
    <div class="divider_color" />
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import 'v2-table/dist/index.css'
import V2Table from 'v2-table'
Vue.use(V2Table)

export default {
  filters: {
    formatZero (data) {
      if (data === '0') {
        return '-'
      } else {
        return (data || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      }
    },
    formatZeroMobile (data) {
      if (data === '0') {
        return '-'
      } else {
        return (
          'PHP ' + (data || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        )
      }
    }
  },
  data () {
    return {
      active: 'ppwc',
      eventName: 'pastevent',
      ppwc_active: 'report',
      report: true,
      items: [
        { name: 'Day1', index: '1' },
        { name: 'Day2', index: '2' },
        { name: 'Day3', index: '3' },
        { name: 'Day4', index: '4' },
        { name: 'Day5', index: '5' },
        { name: 'Day6', index: '6' },
        { name: 'FinalDay', index: '7' }
      ],
      report_index: '1',
      result_status: true,
      result_index: '1',
      schedule: [],
      result: {
        images: []
      },
      page: {
        now: 1,
        total: 1,
        per_num: 10
      }
    }
  },
  computed: {
    images: function () {
      let nums = {
        pc: {
          '1': ['1_01', '1_02', '1_03', '1_04', '1_05', '1_06', '1_07'],
          '2': ['2_01', '2_02', '2_03', '2_04', '2_05', '2_06', '2_07'],
          '3': [
            '3_01',
            '3_02',
            '3_03',
            '3_04',
            '3_05',
            '3_06',
            '3_07',
            '3_08',
            '3_08',
            '3_10'
          ],
          '4': ['4_01', '4_02', '4_03', '4_04', '4_05', '4_06', '4_07'],
          '5': ['5_01', '5_02', '5_03', '5_04', '5_05', '5_06', '5_07'],
          '6': ['6_01', '6_02', '6_03', '6_04', '6_05', '6_06', '6_07', '6_08'],
          '7': ['7_01', '7_02', '7_03', '7_04', '7_05', '7_06', '7_07']
        }
      }
      let desize = 'pc'

      return nums[desize][this.report_index].map(item => {
        return desize + '/' + this.report_index + '/images/' + item
      })
    }
  },
  created () {
    this.$store.commit('changeTab', 1)
    // this.getlist()

    // this.result_index = id
    this.updateResultCon(this.$route.params.item)
    // document.querySelector('.middle').scrollIntoView({ block: 'start', behavior: 'smooth' })
  },
  methods: {
    getlist () {
      this.$axios
        .get('/poker-api/competition/schedules')
        .then(res => {
          console.log(res)
          if (res.status === 200 && res.data.code === 0) {
            this.schedule = res.data.data
            this.page.total = Math.ceil(
              res.data.data.length / this.page.per_num
            )
          } else {
            alert('network issue, Please try again later.')
          }
        })
        .catch(() => {
          alert('network issue, Please try again later.')
        })
    },
    updateResultCon (id) {
      this.$axios
        .get('/poker-api/competition/result', {
          params: {
            id
          }
        })
        .then(res => {
          console.log(res)
          if (res.status === 200 && res.data.code === 0) {
            this.result = res.data.data.result
          } else {
            alert('network issue, Please try again later.')
          }
        })
        .catch(() => {
          alert('network issue, Please try again later.')
        })
    },
    changePage (page) {
      this.page.now += page
    },
    toReportCon (num) {
      // this.report = false
      // this.report_index = num.toString()
      // document.querySelector('.middle').scrollIntoView({ block: 'start', behavior: 'smooth' })
      this.$router.push({ name: 'events-ppwc', params: { item: num.toString() } })
    },
    toResultCon (id) {
      console.log(id)
      this.result_status = false
      this.result_index = id
      this.updateResultCon(id)
      document.querySelector('.middle').scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  padding: 30px 24px 60px 24px;
  min-height: 1000px;

  // background-color: transparent;
  // border-width: 0px 0px 30px 0px;
  // border-style: solid;
  // border-image-slice: 0 0 30 0 fill;
  // border-image-repeat: stretched;
  // border-image-source: url('/official_mobile/static/img/bg/blog/3_blog_01/01.png');

  h2 {
    margin: 0px;
  }
  .title {
    font-size: 32px;
    margin-bottom: 30px;
  }
  .image {
    width: 100%;
    display: block;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  p {
    font-size: 26px;
    color:#727272!important;
    /deep/p, /deep/span {
      color:#727272!important;
      font-size: 26px!important;
    }
  }
  /deep/.v2-table {
    margin-top: 30px;
    background-color: inherit;
    .v2-table__body td .cell, .v2-table__footer td .cell {
      color: #727272;
      font-size: 24px;
    }
    .v2-table__cell.v2-table__column-cell {
      color: #727272;
      font-size: 24px;
    }
    .v2-table__cell.v2-table__column-cell, .v2-table__row {
      background-color: inherit;
    }
    .v2-table__cell {
      border-color: #c0c0c0;
    }
  }
}
</style>
